module.exports = __webpack_public_path__ + "img/icon1.28ed3f65.png";